import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { apiFetch, getToken, clearToken, isTokenExpired } from '../dppApi';
import AccountMenu from './AccountMenu';
import '../App.css';

const bloomMark = process.env.PUBLIC_URL + '/BloomFavicon.png';

// The brand account page (route /brand/profile) — the destination of the "My
// Account" pill in the brand dropdown. Deliberately minimal and monochrome,
// mirroring the user ProfilePage's look: a left settings nav (Profile only) and
// a read-only name + email block. No estate planning (brand-irrelevant) and no
// deletion section for now. Guarded like BrandDashboard.
const BrandProfilePage = () => {
    const navigate = useNavigate();
    const token = getToken('brand');

    const [me, setMe] = useState(null);       // { name, email }
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // An expired token still passes a bare `!token` check — mirror BrandDashboard.
        if (!token || isTokenExpired(token)) { clearToken('brand'); navigate('/brand'); return; }
        apiFetch('/api/brand/me', { token })
            .then(setMe)
            .catch(err => setError(err.message))
            .finally(() => setLoading(false));
    }, [token, navigate]);

    // Reset the back stack so Android/browser Back after logout goes Home → exit,
    // not into now-tokenless screens: replace this page with Home, then show login.
    const logout = () => { clearToken('brand'); navigate('/', { replace: true }); navigate('/brand'); };

    const displayName = me?.brand_title || me?.name;

    return (
        <div className="dpp-page">
            <div className="collection-topbar">
                <div className="collection-topbar-brand">
                    <img className="dpp-brand-mark" src={bloomMark} alt="Bloom" />
                    <h1 className="collection-topbar-title">My Account</h1>
                </div>
                <AccountMenu
                    name={displayName}
                    onLogout={logout}
                    onSettings={() => navigate('/brand/profile')}
                />
            </div>
            <div className="account-back">
                <Link to="/brand/dashboard" className="legal-home">← Back to Dashboard</Link>
            </div>

            <div className="settings-wrap dpp-card account-settings">
                <nav className="settings-nav">
                    <button className="snav-item is-active">Profile</button>
                </nav>

                <div className="settings-body">
                    {loading && <p className="collection-status collection-status--flush">Loading…</p>}
                    {error && <p className="dpp-error">{error}</p>}

                    {!loading && !error && (
                        <div className="settings-section">
                            <h2 className="settings-section-title">Profile</h2>
                            <p className="settings-section-sub">Your account details.</p>
                            <div className="settings-readrow">
                                <span className="settings-readrow-label">Name</span>
                                <span className="settings-readrow-value">{displayName || '—'}</span>
                            </div>
                            <div className="settings-readrow">
                                <span className="settings-readrow-label">Email</span>
                                <span className="settings-readrow-value">{me?.email || '—'}</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BrandProfilePage;
